import { useBlogTextMaterials } from '@entities/Blog'

import type { LandingBlockProps } from '@features/landing-page-builder/model/blockRegistry'

import { BlogCarousel } from '@widgets/blog-carousel'
import { BlogPreview } from '@widgets/blog-preview'

import styles from './LandingTextMaterialsBlock.module.scss'

/*
  textMaterials: the "Полезное" section. Materials are loaded by the ids listed
  in the payload and rendered with the same blog widgets as the main page —
  `block` as a carousel, anything else as the preview grid.
*/
interface TextMaterialsPayload {
  name?: string;
  title?: string;
  ids?: Array<string | number>;
}

export default function LandingTextMaterialsBlock ({ block, payload }: LandingBlockProps) {
  const { name, title, ids } = (payload ?? {}) as TextMaterialsPayload

  const materialIds = (ids ?? []).map(String)

  const { textMaterials, loading } = useBlogTextMaterials({ ids: materialIds })

  const heading = name || title || undefined
  const { subtype = 'block' } = block

  if (materialIds.length === 0) {
    return null
  }

  if (!loading && textMaterials.length === 0) {
    return null
  }

  return (
    <div className={styles.root}>
      {subtype === 'block' ? (
        <BlogCarousel title={heading} articles={textMaterials} loading={loading} />
      ) : (
        <BlogPreview title={heading} articles={textMaterials} loading={loading} />
      )}
    </div>
  )
}
